import { State } from './redux/State'
import { Keys } from './redux/Datastore'
import { AssetCollection } from './assets/Asset'
import { WorkordersCollection } from './workorders/WorkordersCollection'
import { Map, fromJS } from 'immutable'
import { QueryString } from './QueryString';
import { Cookie } from './Cookies';
import { build_num } from './Version';
import { Configuration } from './Configuration';




function set_boolean_from_string(state: State, key: string, val: string): State {
    if (!val) {
        return state;
    }
    val = val.toLowerCase()
    let b_val: boolean = false;
    if (val === 'true') {
        b_val = true;
    }
    if (val === '1') {
        b_val = true;
    }
    return state.set_boolean(key, b_val);
}


function set_string_if_valid(s: State, key: string, val: string): State {
    if (val) {
        s = s.set_string(key, val);
    }
    return s
}
function set_number_if_valid(s: State, key: string, val: number): State {
    if (!isNaN(val)) {
        s = s.set_number(key, val);
    }
    return s
}

export function initial_state(): State {

    let r: State = State.wrap(fromJS({

        [Keys.API_GATEWAY]: QueryString.api_gateway,
		[Keys.STORAGE_ACCOUNT_URL]: QueryString.storage_account_url,
//        [Keys.API_TOKEN]: qs.api_token,
        [Keys.CUSTOMER_NAME]: QueryString.customer_name,
        [Keys.DRAWING_HISTORY]: Cookie.read_json_array(Keys.DRAWING_HISTORY),
        [Keys.HARD_CODED_MAP_URL]: null,
        [Keys.ID_CUSTOMER]: QueryString.id_customer,
        [Keys.ID_SEGMENT]: QueryString.id_segment,
        [Keys.IS_FETCHING_ASSETS]: false,
        [Keys.IS_FETCHING_ATTACHMENTS]: false,
        [Keys.IS_HARD_CODED_MAP]: false,
        [Keys.ENABLED_FEATURE_READONLY_MODE]: Configuration.read_only_mode,
        [Keys.KEY_IS_IOS_DEVICE]: !!navigator.platform.match(/iPhone|iPod|iPad/), // it looks silly, but the two 'nots' are necessary. test it out in a browser console session. https://stackoverflow.com/questions/9038625/detect-if-device-is-ios
        [Keys.MENU_ASSETS_CONTENT]: [],
        [Keys.MENU_ASSETS_EXPANDED]: true,
        [Keys.MENU_ATTACHMENTS_EXPANDED]: true,
        [Keys.MENU_BUILDINGS_EXPANDED]: true,
        [Keys.MENU_FINDINGS_EXPANDED]: true,
        [Keys.MENU_FLOORS_EXPANDED]: true,
        [Keys.MENU_WORKORDERS_EXPANDED]: true,
        [Keys.STATE_CREATING_FINDING]: false,
        [Keys.STATE_CREATING_WORKORDER]: false,
        [Keys.STATE_FETCHING_FINDINGS]: false,
        [Keys.STATE_PRINTING_FINDINGS]: false,
        [Keys.TOKEN_IS_BAD]: false,
        [Keys.WORKORDERS_QUERY]: null,

    }));
    r.set_assets(AssetCollection.empty());
    r.set_workorders(WorkordersCollection.empty_collection);

    // get cookie values
    var cookie_buildnum = Cookie.read("buildnum");
    if (cookie_buildnum != build_num()) {
        console.error("NEW BUILD DETECTED! CLEAR COOKIES!")
        Cookie.write("buildnum", build_num())
    }


    if (QueryString.id_floor) {
        r = r.set_string(Keys.ID_FLOOR, QueryString.id_floor.toString());
    }

    if (QueryString.id_building) {
        r = r.set_string(Keys.ID_BUILDING, QueryString.id_building.toString());
    }
    return r;

}


// WEBPACK FOOTER //
// ./src/ts/InitialState.ts